























import { Component, Vue } from "vue-property-decorator";
import QRCode from "qrcodejs2";
import VueClipboard from "vue-clipboard2"; // 复制粘贴插件
Vue.use(VueClipboard);
@Component({
  components: { QRCode },
})
export default class Home extends Vue {
  public modal = false;
  public detail: any = {};
  public url = "";
  // 显示
  public show(details, urls) {
    this.detail = details;
    this.url = urls;
    this.modal = true;
  }
  public download() {
    window.location.href = this.url;
  }
}
